import {useState} from "react";

import {MagazineService} from "../../../serverService/magazineService/MagazineService";
import {LoadingHelper} from "../../../util/LoadingHelper";
import {useLoadingDispatcher} from "../../../context/LoadingContext";
import {magazineTypes} from "../../../pages/magazine/MagazineList";
import {css} from "@emotion/css";
import {
    RaikoButtonPrimary,
    RaikoCustomSelect, raikoCustomSelectItemGenerator, RaikoFlexAlignEnd,
    RaikoGridOneColumn, RaikoSimpleInputOutlined,
    showErrorMessage,
    showSuccessMessage,
    showWarningMessage
} from "@moeindal/base-raiko-panel-components";
import {detectServerErrorMessage} from "../../../util/detectServerErrorMessage";

const MagazineAddItem = ({handleAddNewItem}) => {

    const loading = new LoadingHelper(useLoadingDispatcher())
    const service = new MagazineService()

    const [title, setTitle] = useState("");
    const [type, setType] = useState(magazineTypes.ARTICLE.id);

    function handleCreatePost() {
        if (title.length > 0) {
            loading.show()
            service.createNewPost(title, type)
                .then(response => {
                    handleAddNewItem(response)

                    showSuccessMessage("مطلب جدید با موفقیت افزوده شد.")
                    setTitle("")
                    setType(magazineTypes.ARTICLE.id)
                }).catch(reason => {
                showErrorMessage(detectServerErrorMessage(reason))
            }).finally(_ => {
                loading.hide()
            })

        } else {
            showWarningMessage("لطفا عنوان مطلب را به درستی وارد نمایید.")
        }
    }

    return (
        <RaikoGridOneColumn className={css`padding: 0 1rem 1rem 1rem;`}>
            <RaikoSimpleInputOutlined labelText={"عنوان"} setValue={setTitle} value={title}/>
            <RaikoCustomSelect
                labelText={"نوع"}
                setValue={setType}
                items={[
                    raikoCustomSelectItemGenerator(magazineTypes.ARTICLE.id, magazineTypes.ARTICLE.title),
                    raikoCustomSelectItemGenerator(magazineTypes.VIDEO.id, magazineTypes.VIDEO.title),
                    raikoCustomSelectItemGenerator(magazineTypes.PODCAST.id, magazineTypes.PODCAST.title),
                    raikoCustomSelectItemGenerator(magazineTypes.PHOTO_GALLERY.id, magazineTypes.PHOTO_GALLERY.title),
                ]}
                value={type}/>
            <RaikoFlexAlignEnd>
                <RaikoButtonPrimary label={"افزودن"} onClick={handleCreatePost}/>
            </RaikoFlexAlignEnd>
        </RaikoGridOneColumn>
    )
}

export default MagazineAddItem;